<template>
    <div class="container">
       <iframe :src="pdf_src" frameborder="0" allowtransparency="true" class="pdf"></iframe>
    </div>
</template>
<script>
export default {
  name: 'Preview',
  data () {
    return {
        pdf_src: '',
    }
  },
  watch: {
    $route(){
        let path = this.$route.query.path
        if (process.env.NODE_ENV === 'development') {
            this.pdf_src = `${window.location.origin}/pdf/web/viewer.html?file=/${path}`
        } else {
            let origin = location.origin
            let pathname = location.pathname
            let signIndex = pathname.search('index.html');
            let sign = signIndex > 0 ? pathname.substring(0, signIndex) : pathname;
            let url = sign.charAt(sign.length-1) == "/" ? sign : sign + '/';
            this.pdf_src = `${origin}${url}${path}`
        }
        // console.log(22, this.pdf_src)
    },
},
  mounted () {
    this.$store.commit('showPrev', false)
    let path = this.$route.query.path
    if (process.env.NODE_ENV === 'development') {
        this.pdf_src = `${window.location.origin}/pdf/web/viewer.html?file=/${path}`
    } else {
        // this.pdf_src = `./pdf/web/viewer.html?file=../../${path}`
        let origin = location.origin
        let pathname = location.pathname
        let signIndex = pathname.search('index.html');
        let sign = signIndex > 0 ? pathname.substring(0, signIndex) : pathname;
        let url = sign.charAt(sign.length-1) == "/" ? sign : sign + '/';
        this.pdf_src = `${origin}${url}${path}`
    }
    console.log(11, this.pdf_src)
    console.log(22, location)
  },

  methods: {
     
  }
}
</script>
<style lang="less" scoped>
    .container {
        position:relative;
        // margin-bottom: 20px;
        width: 60%;
        height: 98%;
        margin: 0 auto;
    }
    .pdf {
        overflow: hidden;
        width: 100%;
        height: 100%;
    }
</style>
